import Colors from '@/constants/Colors';
import MediaQueryBreakpoints from '@/constants/MediaQueryBreakpoints';
import styled from 'styled-components';

export const StyledDragPage = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .draggable-container {
    flex: 1;
    display: grid;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
  }

  .title {
    font-size: 20px;
    text-align: center;
  }

  .texts-and-gaps {
    flex: 1;
    display: grid;
    grid-template-rows: auto 1fr;

    .texts {
      margin-top: 20px;
      display: flex;

      .text-with-audio {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;

        .text {
          font-size: 22px;
          padding: 0 10px;
          text-align: center;

          .audio-button {
            display: inline-flex;
            margin-left: 5px;
          }
        }
      }
    }

    .text-with-gaps {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: no-wrap;
      justify-content: space-between;
      gap: 20px;

      .gap-wrapper {
        height: 100%;
        flex: 1;

        .gap-droppable {
          height: 100%;
          width: 100%;
          .gap {
            margin-top: 10px;
            border-radius: 12px;
            box-shadow: inset -1px 1px 2px 2px ${Colors.lighterGray};
            background-color: ${Colors.backgroundPaleBlue};
            height: calc(100% - 10px);
            width: 100%;
            position: relative;

            .incorrect-image {
              opacity: 0.2;
            }

            .option {
              height: 100%;
            }

            .correct-answer {
              position: absolute;
              top: calc(100% + 20px);
              left: 0px;
              height: 100%;
              width: 100%;
              outline: 1px solid ${Colors.green};
              border: 8px solid white;
              background-color: white;
              display: flex;
              flex-direction: column;
              gap: 8px;

              .info {
                line-height: 1;
                font-size: 15px;
              }

              .image-container {
                width: 100%;
                flex: 1;
                height: 0;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                  max-width: 100%;
                  max-height: 100%;
                  object-fit: contain;
                }
              }
            }
            .feedback {
              &.correct {
                font-size: 200%;
                .feedback-icon {
                  position: absolute;
                  left: 35%;
                }
              }
              &.incorrect {
                top: 10px;
                left: 0;
                font-size: 200%;
              }
            }
          }
        }
      }
    }
  }

  .images {
    flex: 1;
    margin-top: 20px;
    margin-bottom: 50px;
    display: flex;
    justify-content: space-between;
    gap: 20px;

    .option-wrapper {
      position: relative;
      background-color: #f0f0f0;
      border-radius: 12px;
      background-color: ${Colors.backgroundPaleBlueDark};
      flex: 1;
      height: 100%;

      &.invisible {
        visibility: hidden;
      }
    }
  }
  .option {
    border-radius: 0;
    padding: 0;
    background-color: white;
    position: absolute;
    width: 100%;
    max-height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    &.dragged {
    }
    &.dropped {
      visibility: hidden;
    }

    img {
      z-index: 2;
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
  }
  @media only screen and (max-height: ${MediaQueryBreakpoints.sm}) and (orientation: landscape) {
    .title {
      font-size: 14px;
    }
    .draggable-container {
      gap: 10px;
      .texts-and-gaps {
        flex: 1;
        display: grid;
        grid-template-rows: auto 1fr;

        .texts {
          margin-top: 5px;
          .text-with-audio {
            .text {
              font-size: 16px;
            }
          }
        }
      }

      .images {
        margin-top: 10px;
        margin-bottom: 30px;
      }
    }
  }
`;
